<template>
  <nav class="navbar navbar-expand-lg navbar-dark primary">
    <div class="container-fluid">
      <a class="navbar"></a>
      <div class="collapse navbar-collapse text-center mx-auto" id="main_nav">
        <ul class="navbar-nav">
          <li v-if="$route.matched[0].name != 'Home'" class="nav-item">
            <a class="nav-link" href="../"><ICON_Home :size="icon_size" /></a>
          </li>
          <li
            class="nav-item"
            :class="[
              'nav-item',
              op.id == $route.matched[0].name ? 'active' : 'not-active',
            ]"
            v-for="op in menu"
            :key="op.id"
          >
            <a class="nav-link" :href="op.href">{{ op.text }}</a>
          </li>
        </ul>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#main_nav"
        id="burger"
        :class="{ active: isBurgerActive }"
        @click.prevent="toggle"
      >
        <button type="button" class="burger-button" title="Menu">
          <span class="burger-bar burger-bar--1"></span>
          <span class="burger-bar burger-bar--2"></span>
          <span class="burger-bar burger-bar--3"></span>
        </button>
        <!-- <span class="navbar-toggler-icon"></span> -->
      </button>
      <!-- navbar-collapse.// -->
    </div>
    <!-- container-fluid.// -->
  </nav>
</template>

<script>
import ICON_Home from "@/assets/icons/Home.vue";

export default {
  components: {
    ICON_Home,
  },
  data: () => ({
    isBurgerActive: false,
    menu: [
      { id: "Reflection", text: "Reflection", href: "../../reflection" },
      // { id: "MassReading", text: "Mass Reading", href: "../mass-reading" },
      // { id: "VaticanNews", text: "Vatican News", href: "../vatican-news" },
      { id: "Prayers", text: "Prayers", href: "../../prayers" },
      // {
      //   id: "SaintOfTheDay",
      //   text: "Saint of the Day",
      //   href: "../saint-of-the-day",
      // },
      { id: "AboutMe", text: "About Me", href: "../../about-me" },
    ],
  }),
  methods: {
    toggle() {
      this.isBurgerActive = !this.isBurgerActive;
      var navMain = document.getElementById("main_nav");
      var buttonmenu = document.getElementById("burger");
      navMain.addEventListener("click", function () {
        navMain.classList.remove("show"), buttonmenu.classList.remove("active");
      });
    },
  },
};
</script>
<style scoped>
li.nav-item.active a {
  color: #1890ff !important;
}
.navbar-brand {
  padding: 0px 80px;
}
.hidden {
  visibility: hidden;
}

button {
  cursor: pointer;
}

/* remove blue outline */
button:focus {
  outline: 0;
}

.burger-button {
  position: relative;
  height: 30px;
  width: 32px;
  display: block;
  z-index: 999;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  pointer-events: all;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.burger-bar {
  background-color: #000000;
  position: absolute;
  top: 50%;
  right: 6px;
  left: 6px;
  height: 2px;
  width: auto;
  margin-top: -1px;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
    background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.burger-bar--1 {
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}

.burger-bar--2 {
  transform-origin: 100% 50%;
  transform: scaleX(0.8);
}

.burger-button:hover .burger-bar--2 {
  transform: scaleX(1);
}

.no-touchevents .burger-bar--2:hover {
  transform: scaleX(1);
}

.burger-bar--3 {
  transform: translateY(6px);
}

#burger.active .burger-button {
  transform: rotate(-180deg);
}

#burger.active .burger-bar {
  background-color: #000000;
}

#burger.active .burger-bar--1 {
  transform: rotate(45deg);
}

#burger.active .burger-bar--2 {
  opacity: 0;
}

#burger.active .burger-bar--3 {
  transform: rotate(-45deg);
}

a.nav-link > a:hover {
  color: #fff;
}
.navbar .navbar-nav .nav-link {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
}

.navbar-dark .navbar-nav .nav-link:focus {
  color: #000000 !important;
}
@media (min-width: 992px) {
  .navbar .megamenu {
    left: 10px !important;
    width: 98% !important;
  }
}
.navbar .navbar-nav .nav-link:hover {
  color: #000000;
}
.sm-icons {
  flex-direction: row;
}
@media only screen and (max-width: 960px) {
  .sm-icons .nav-item {
    padding-right: 1em;
  }
}
.navbar .megamenu {
  padding: 1rem;
}

/* ============ desktop view ============ */
@media all and (min-width: 992px) {
  .navbar .has-megamenu {
    position: static !important;
  }
  .navbar .megamenu {
    left: 0;
    right: 0;
    width: 100%;
    margin-top: 0;
  }
  nav.navbar.navbar-expand-lg.navbar-dark.primary {
    position: absolute;
  }
}
.navbar-collapse {
  flex-grow: 0;
  padding: 0px 60px;
}
/* ============ desktop view .end// ============ */

/* ============ mobile view ============ */
@media (max-width: 451px) and (min-width: 0px) {
  div#main_nav {
    width: 95% !important;
  }
  img.logo {
    width: 70px !important;
    margin: 0px 10px !important;
  }
}

@media all and (max-width: 991px) {
  .navbar.fixed-top .navbar-collapse,
  .navbar.sticky-top .navbar-collapse {
    overflow-y: auto;
    max-height: 90vh;
    margin-top: 10px;
  }
  nav.navbar.navbar-expand-lg.navbar-dark.primary {
    position: fixed;
  }
  .navbar-brand {
    padding: 0px 30px !important;
  }
  nav.navbar {
    bottom: 0;
  }
  div#main_nav {
    bottom: 80px !important;
  }

  div#main_nav {
    position: absolute;
    left: 0;
    width: 97%;
    margin: 10px;
    background-color: #f6f7fd;
    z-index: 99;
    -webkit-box-shadow: 0px 15px 20px 0px rgb(0 0 0 / 10%);
    box-shadow: 0px 15px 20px 0px rgb(0 0 0 / 10%);
    padding: 10px 20px;
    max-height: 550px;
    overflow-y: scroll;
    border-top: 1px solid #eee;
    border-radius: 6px;
  }
}
img.logo {
  width: 70px;
  margin: 0px 50px;
}

nav.navbar.navbar-expand-lg.navbar-dark.primary {
  z-index: 99;
  -webkit-box-shadow: 0px 20px 50px 0px rgb(0 0 0 / 5%);
  box-shadow: 0px 20px 50px 0px rgb(0 0 0 / 5%);
  background: #f6f7fd;
  padding: 10px 0;
  height: 80px;
  width: 100%;
  margin: 0px 0px 0px 0px;
}
li.nav-item > a {
  padding: 10px;
  text-decoration: none;
}
li.nav-item {
  padding: 10px 15px;
  margin-bottom: 0px !important;
}
.submenu {
  float: left;
  background: #fff;
  -webkit-box-shadow: 0px 5px 20px #0000001a;
  box-shadow: 0px 5px 20px #0000001a;
}
</style>